import React from "react";
import { baseUrl } from "../../config/clientsConfig";
import axios from "axios";

const PresentationPropertyService = {
  createProperty: async (propertyData) => {
    return axios.post(
      `${baseUrl}/prospect-properties/presentation`,
      propertyData
    );
  },
  getProperties: async (body) => {
    return axios.post(`${baseUrl}/properties`, body);
  },
  getPropertyById: async (propertyId) => {
    return axios.get(
      `${baseUrl}/prospect-properties/presentation/get?prospectPropertyId=${propertyId}`
    );
  },
  updateProperty: async (propertyData) => {
    return axios.put(
      `${baseUrl}/prospect-properties/presentation/update`,
      propertyData
    );
  },
  getProspectPropertyIdBasedOnPropertyId: async (propertyId) => {
    return axios.get(
      `${baseUrl}/prospect-properties/presentation/get?prospectPropertyId=${propertyId}`
    );
  },

  // layout units
  getUnitsLayoutsByPropertyId: async (id) => {
    return axios.get(`${baseUrl}/prospect-properties/presentation/layout-units/list?docId=${id}`);
  },
  updateLayoutUnit: async (unitData) => {
    return axios.put(`${baseUrl}/prospect-properties/presentation/layout-units/update`, unitData);
  },
  createLayoutUnit: async (unitData) => {
    return axios.post(`${baseUrl}/prospect-properties/presentation/layout-units/create`, unitData);
  },

  
};

export default PresentationPropertyService;
